

module.exports = __webpack_require__.stylable.create(
    "Avatar554190115",
    {"classes":{"root":"Avatar554190115__root"},"vars":{},"stVars":{"AvatarBorderColor":"\"fallback(color(--headerLinksColor), color(color-8))\"","AvatarSize":"'\"unit(fallback(--profilePictureSize, 60), px)\"'","MobileAvatarSize":"'\"unit(fallback(--m_profilePictureRadius, 36), px)\"'","AvatarPaddingTopBottom":"'\"unit(fallback(--profilePicturePaddingVer, 0), px)\"'","AvatarPaddingRightLeft":"'\"unit(fallback(--profilePicturePaddingHor, 0), px)\"'","MobileAvatarPaddingTopBottom":"'\"unit(fallback(--m_profilePicturePaddingVer, 0), px)\"'","MobileAvatarPaddingRightLeft":"'\"unit(fallback(--m_profilePicturePaddingHor, 0), px)\"'","MobileAvatarFontSize":"'\"unit(fallback(--m_avatarFontSize, 18), px)\"'","AvatarBorderRadius":"'\"unit(fallback(--profilePictureRadius, 50), %)\"'"},"keyframes":{}},
    "",
    7,
    "Avatar554190115",
    null
);
